// Icon imports
import Home from '~/assets/svg/menu/Home.svg'
import DVert from '~/assets/svg/menu/D-Vert.svg'
import Localizacao from '~/assets/svg/menu/Localizacao.svg'
import Empreendimento from '~/assets/svg/menu/Empreendimento.svg'
import Sustentabilidade from '~/assets/svg/menu/Sustentabilidade.svg'
import Apartamentos from '~/assets/svg/menu/Apartamentos.svg'
import Plantas from '~/assets/svg/menu/Plantas.svg'
// import Easyhome from '~/assets/svg/menu/Easyhome.svg'
import Projetistas from '~/assets/svg/menu/Projetistas.svg'
import Diferenciais from '~/assets/svg/menu/Diferenciais.svg'
import FaleConosco from '~/assets/svg/menu/Fale-conosco.svg'
import AcompanheObra from '~/assets/svg/menu/AcompanheObra.svg'

export default [
  {
    name: 'Home',
    icon: Home,
    to: '#Home',
  },
  {
    name: 'D/Vert',
    icon: DVert,
    to: '#DVert',
  },
  {
    name: 'Localização',
    icon: Localizacao,
    to: '#Localizacao',
  },
  {
    name: 'O Empreendimento',
    icon: Empreendimento,
    to: '#Empreendimento',
  },
  {
    name: 'Sustentabilidade',
    icon: Sustentabilidade,
    to: '#Sustentabilidade',
  },
  {
    name: 'Apartamentos',
    icon: Apartamentos,
    to: '#Apartamentos',
  },
  {
    name: 'Plantas',
    icon: Plantas,
    to: '#Plantas',
  },
  // {
  //   name: 'Easyhome',
  //   icon: Easyhome,
  //   to: '#Easyhome',
  // },
  {
    name: 'Projetistas',
    icon: Projetistas,
    to: '#Projetistas',
  },
  {
    name: 'Acompanhe a obra',
    icon: AcompanheObra,
    to: 'acompanhe-a-obra/',
  },
  {
    name: 'Diferenciais Dimas',
    icon: Diferenciais,
    to: '#Diferenciais',
  },
  {
    name: 'Fale Conosco',
    icon: FaleConosco,
    to: '#FaleConosco',
  },
]
